import React from "react";
import Golfers from "./Golfers";
import Entries from "./Entries";
import Standings from "./Standings";
import Header from "./Header";
import Footer from "./Footer";

export default function Main() {
    return (
        <div>
            <Header />
            <div className="flex flex-col lg:flex-row justify-around flex-wrap">
                <Standings />
                <Golfers />
            </div>
            <Entries />
            <Footer />
        </div>
    );
}